import React, { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import PostCard from "../Home/PostCard";
// import {posts} from "../../data/home" ;
import "../../styles/home.css";
import axios from "axios";

function RightProfile({ curUser }) {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    axios
      .get("api/invitation/", {
        headers: {
          "x-auth-token": localStorage.getItem("user"),
        },
      })
      .then((res) => {
        setPosts(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <div className="rightProfile rightHome">
      {posts.map((post) => (
        <PostCard post={post} curUser={curUser} />
      ))}
    </div>
  );
}

export default RightProfile;
